import * as z from "zod";

export const refulfillmentDashboardOrdersViewSchema = z.enum([
  "picking",
  "packing",
  "fulfilled_today",
  "matrix",
  "unable_to_fulfill",
  "unable_to_pick",
  "partially_pickable",
  "on_hold",
  "open_over_24h",
  "transferred",
  "canceled",
]);

export const refulfillmentDashboardMatrixRowKeySchema = z.enum([
  "needs_picking",
  "needs_packing",
  "blocked",
  "total",
]);

export const refulfillmentDashboardOrderRowSchema = z.object({
  fulfillmentGroupId: z.string(),
  orderName: z.string().nullable(),
  merchantTeamId: z.string(),
  merchantName: z.string(),
  receivedAt: z.string(),
  orderedAt: z.string().nullable(),
  status: z.string(),
  pickStatus: z.string().nullable(),
});

const MATRIX_FIELDS = ["row", "slotStart"] as const;

export const getRefulfillmentDashboardOrders = {
  name: "getRefulfillmentDashboardOrders" as const,
  input: z
    .object({
      view: refulfillmentDashboardOrdersViewSchema,
      row: refulfillmentDashboardMatrixRowKeySchema.optional(),
      /** A dashboard `matrix[].start`; the cell covers the hour after it. */
      slotStart: z.iso.datetime().optional(),
      teamIds: z.array(z.string()).optional(),
      /** The viewer's IANA timezone, as sent to `getRefulfillmentDashboard`. */
      timezone: z.string(),
      page: z.number().int().min(0),
      pageSize: z.number().int().min(1).max(50).default(10),
    })
    .superRefine((input, ctx) => {
      const matrix = input.view === "matrix";
      for (const field of MATRIX_FIELDS) {
        const present = input[field] !== undefined;
        if (matrix && !present) {
          ctx.addIssue({
            code: "custom",
            message: `${field} is required for the matrix view`,
            path: [field],
          });
        } else if (!matrix && present) {
          ctx.addIssue({
            code: "custom",
            message: `${field} only applies to the matrix view`,
            path: [field],
          });
        }
      }
    }),
  output: z.object({
    rows: z.array(refulfillmentDashboardOrderRowSchema),
    total: z.number(),
    truncated: z.boolean(),
    generatedAt: z.string(),
  }),
};

export type RefulfillmentDashboardOrdersInput = z.infer<
  (typeof getRefulfillmentDashboardOrders)["input"]
>;
export type RefulfillmentDashboardOrders = z.infer<
  (typeof getRefulfillmentDashboardOrders)["output"]
>;
export type RefulfillmentDashboardOrdersView = z.infer<
  typeof refulfillmentDashboardOrdersViewSchema
>;
export type RefulfillmentDashboardMatrixRowKey = z.infer<
  typeof refulfillmentDashboardMatrixRowKeySchema
>;
export type RefulfillmentDashboardOrderRow = z.infer<
  typeof refulfillmentDashboardOrderRowSchema
>;
